import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "flex items-center mb-2" }
const _hoisted_3 = {
  key: 0,
  class: "mt-auto"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined text-success-dark" }, "check_circle", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined text-danger-dark" }, "warning", -1)
const _hoisted_6 = { class: "max-w-lg m-2 overflow-y-scroll rounded-sm max-h-64 bg-light" }
const _hoisted_7 = { class: "ml-auto" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "text-base material-icons" }, " delete ", -1)
const _hoisted_9 = { class: "flex flex-col py-3 mb-12 space-y-2 md:flex-row md:space-x-4 md:space-y-0 md:items-start" }
const _hoisted_10 = { class: "grid w-full grid-cols-6 gap-5 md:grid-cols-12" }
const _hoisted_11 = { class: "flex w-full" }
const _hoisted_12 = { class: "mr-auto" }
const _hoisted_13 = {
  key: 0,
  class: "flex items-center ml-8 space-x-2 text-danger-dark"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "mr-2 text-sm material-icons-outlined" }, "visibility_off", -1)
const _hoisted_15 = {
  key: 1,
  class: "flex col-span-7 space-x-2 md:row-span-2"
}
const _hoisted_16 = { class: "flex w-full" }
const _hoisted_17 = { class: "" }
const _hoisted_18 = {
  key: 0,
  class: "flex items-center ml-2 ml-4 space-x-2 text-danger-dark"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "mr-2 text-sm material-icons-outlined" }, "visibility_off", -1)
const _hoisted_20 = { class: "flex w-full" }
const _hoisted_21 = { class: "" }
const _hoisted_22 = {
  key: 0,
  class: "flex items-center ml-3 space-x-2 text-danger-dark"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "mr-2 text-sm material-icons-outlined" }, "visibility_off", -1)
const _hoisted_24 = { class: "flex w-full" }
const _hoisted_25 = { class: "mr-auto" }
const _hoisted_26 = {
  key: 0,
  class: "flex items-center ml-8 space-x-2 text-danger-dark"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "mr-2 text-sm material-icons-outlined" }, "visibility_off", -1)
const _hoisted_28 = { class: "text-sm" }
const _hoisted_29 = {
  key: 3,
  class: "col-span-12"
}
const _hoisted_30 = { class: "mb-1" }
const _hoisted_31 = { class: "text-muted mb-2 text-sm" }
const _hoisted_32 = { class: "w-full flex items-start space-x-4" }
const _hoisted_33 = { class: "w-full" }
const _hoisted_34 = {
  key: 0,
  class: "w-full"
}
const _hoisted_35 = { class: "flex items-center" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons text-muted mr-1",
  style: {"font-size":"18px !important"}
}, "insert_drive_file", -1)
const _hoisted_37 = { class: "text-sm mr-2" }
const _hoisted_38 = { class: "text-xs text-muted mr-2" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons-outlined text-muted",
  style: {"font-size":"18px !important"}
}, "file_download", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", {
  style: {"font-size":"16px !important"},
  class: "material-icons"
}, "close", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_CodeExecutionResults = _resolveComponent("CodeExecutionResults")!
  const _component_Btn = _resolveComponent("Btn")!
  const _component_SegmentedControls = _resolveComponent("SegmentedControls")!
  const _component_CodeEditor = _resolveComponent("CodeEditor")!
  const _component_TextEditor = _resolveComponent("TextEditor")!
  const _component_FileUpload = _resolveComponent("FileUpload")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      ((_ctx.executionResultsSlots ?? []).length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_ctx.executingSolution)
              ? (_openBlock(), _createBlock(_component_Spinner, {
                  key: 0,
                  class: "mb-2 ml-0.5"
                }))
              : (_ctx.allTestsPass)
                ? (_openBlock(), _createBlock(_component_Tooltip, {
                    key: 1,
                    textCode: 'testcase_passes'
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_Tooltip, {
                    key: 2,
                    placement: 'right',
                    allowHoverOnText: true,
                    textCode: 'testcase_fails'
                  }, {
                    body: _withCtx(() => [
                      _createElementVNode("div", _hoisted_6, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nonPassingExecutionResults, (executionResults, index) => {
                          return (_openBlock(), _createBlock(_component_CodeExecutionResults, {
                            key: 'test-' + _ctx.modelValue.id + '-non-passing-' + index,
                            executionResults: executionResults,
                            testCases: _ctx.executionResultsSlots?.[0].exercise.testcases,
                            showTestIds: [_ctx.modelValue.id],
                            onlyErrors: true
                          }, null, 8, ["executionResults", "testCases", "showTestIds"]))
                        }), 128))
                      ])
                    ]),
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_Btn, {
          outline: true,
          variant: 'icon',
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('delete'))),
          tooltip: _ctx.$t('exercise_editor.delete_testcase'),
          class: "transition-opacity duration-100 opacity-50 hover:opacity-100"
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }, 8, ["tooltip"])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", {
          class: _normalizeClass({
						'col-span-6':
							_ctx.testCaseType === _ctx.ExerciseType.JS || _ctx.testCaseType === _ctx.ExerciseType.PYTHON,
						'md:col-span-5 col-span-7': _ctx.testCaseType === _ctx.ExerciseType.C,
					})
        }, [
          _createVNode(_component_SegmentedControls, {
            modelValue: _ctx.modelValue.testcase_type,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.onUpdate('testcase_type', $event))),
            options: _ctx.testcaseTypeOptions
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("exercise_editor.testcase_type")), 1)
            ]),
            _: 1
          }, 8, ["modelValue", "options"])
        ], 2),
        (_ctx.testCaseType === _ctx.ExerciseType.JS || _ctx.testCaseType === _ctx.ExerciseType.PYTHON)
          ? (_openBlock(), _createBlock(_component_CodeEditor, {
              key: 0,
              onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('blur'))),
              class: "col-span-6 md:row-span-2",
              size: 'sm',
              modelValue: _ctx.modelValue.code,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.onUpdate('code', $event)))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t("exercise_editor.testcase_code")), 1),
                  (
								_ctx.modelValue.testcase_type === _ctx.ExerciseTestCaseType.HIDDEN ||
								_ctx.modelValue.testcase_type === _ctx.ExerciseTestCaseType.SHOW_TEXT_ONLY
							)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _hoisted_14,
                        _createTextVNode(_toDisplayString(_ctx.$t("exercise_editor.hidden_to_students")), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createVNode(_component_CodeEditor, {
                onBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('blur'))),
                class: "w-1/2",
                size: 'sm',
                modelValue: _ctx.modelValue.stdin,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.onUpdate('stdin', $event)))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$t("exercise_editor.testcase_stdin")), 1),
                    (
									_ctx.modelValue.testcase_type === _ctx.ExerciseTestCaseType.HIDDEN ||
									_ctx.modelValue.testcase_type === _ctx.ExerciseTestCaseType.SHOW_TEXT_ONLY
								)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _hoisted_19,
                          _createTextVNode(_toDisplayString(_ctx.$t("misc.hidden")), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_CodeEditor, {
                onBlur: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('blur'))),
                class: "w-1/2",
                size: 'sm',
                modelValue: _ctx.modelValue.expected_stdout,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.onUpdate('expected_stdout', $event)))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.$t("exercise_editor.testcase_expected_stdout")), 1),
                    (
									_ctx.modelValue.testcase_type === _ctx.ExerciseTestCaseType.HIDDEN ||
									_ctx.modelValue.testcase_type === _ctx.ExerciseTestCaseType.SHOW_TEXT_ONLY
								)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _hoisted_23,
                          _createTextVNode(_toDisplayString(_ctx.$t("misc.hidden")), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])),
        _createVNode(_component_TextEditor, {
          onBlur: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('blur'))),
          class: _normalizeClass({
						'col-span-6':
							_ctx.testCaseType === _ctx.ExerciseType.JS || _ctx.testCaseType === _ctx.ExerciseType.PYTHON,
						'md:col-span-5 col-span-7': _ctx.testCaseType === _ctx.ExerciseType.C,
					}),
          modelValue: _ctx.modelValue.text,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.onUpdate('text', $event)))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.$t("exercise_editor.testcase_text")), 1),
              (_ctx.modelValue.testcase_type === _ctx.ExerciseTestCaseType.HIDDEN)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _hoisted_27,
                    _createTextVNode(_toDisplayString(_ctx.$t("exercise_editor.hidden_to_students")), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["class", "modelValue"]),
        (_ctx.testCaseType === _ctx.ExerciseType.C && !_ctx.showAttachmentArea)
          ? (_openBlock(), _createBlock(_component_Btn, {
              key: 2,
              class: "-mt-4 col-span-3 w-max",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showAttachmentArea = true)),
              variant: 'primary-borderless',
              size: 'xs'
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t("exercise_editor.testcase_add_attachments")), 1)
              ]),
              _: 1
            }))
          : (_ctx.testCaseType === _ctx.ExerciseType.C)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _createElementVNode("h5", _hoisted_30, _toDisplayString(_ctx.$t("exercise_editor.testcase_attachments")), 1),
                _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.$t("exercise_editor.testcase_attachments_description")), 1),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createVNode(_component_FileUpload, {
                      small: true,
                      autoUpload: true,
                      modelValue: _ctx.attachmentProxy,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.attachmentProxy) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  (_ctx.attachments.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attachments, (testcaseAttachment) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "flex items-center w-full my-0.5",
                            key: 'attachment-' + testcaseAttachment.id
                          }, [
                            _createElementVNode("div", _hoisted_35, [
                              _hoisted_36,
                              _createElementVNode("p", _hoisted_37, _toDisplayString(testcaseAttachment.attachment.name), 1),
                              _createElementVNode("p", _hoisted_38, _toDisplayString(testcaseAttachment.attachment.size / 1000) + " KB ", 1),
                              _createVNode(_component_Btn, {
                                onClick: ($event: any) => (_ctx.$emit('downloadAttachment', testcaseAttachment)),
                                size: 'xs',
                                outline: true,
                                variant: 'icon'
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_39
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _createVNode(_component_Btn, {
                              class: "transition-opacity duration-100 ml-auto mr-2.5 opacity-50 hover:opacity-100",
                              onClick: ($event: any) => (_ctx.$emit('deleteAttachment', testcaseAttachment)),
                              variant: 'icon',
                              size: 'xs',
                              outline: true
                            }, {
                              default: _withCtx(() => [
                                _hoisted_40
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
      ])
    ])
  ]))
}